export const images = [
    {id:1, original: '/images/services/2/highlights/c2-hp1.jpg'},
    {id:2, original: '/images/services/2/highlights/c2-hp2.jpg'},
    {id:2, original: '/images/services/2/highlights/c2-hp3.jpg'},
    {id:2, original: '/images/services/2/highlights/c2-hp4.jpg'},
    {id:2, original: '/images/services/2/highlights/c2-hp5.jpg'}
]
